export const Departments = [
    {
        ID: 'IT',
        name: '信息技术与咨询(IT Consultant)',
        description: ['IT_D'],
        img:"https://i.ibb.co/5jcxVP9/We-Chat-Screenshot-20230817134425.png"
    },
    {
        ID: 'PA',
        name: '策划管理部(Plan and Administration)',
        description: ['PA_D'],
        img:"https://i.ibb.co/jM7wxSX/We-Chat-Screenshot-20230817135706.png"
    },
    {
        ID: 'PR',
        name: '外联部(Public Relation)',
        description: ['PR_D'],
        img:"https://i.ibb.co/YQWHvc2/We-Chat-Screenshot-20230817134448.png"
    },
    {
        ID: 'TR',
        name: '财务部(Treasure)',
        description: ['TR_D'],
        img:"https://i.ibb.co/1R5Fv4H/image.png"
    },
    {
        ID: 'Greeter',
        name: '什么是UGACSSA',
        description: [
            'CSSA_1',
            'CSSA_2',
            'CSSA_3'
        ]
        , img:"https://i.ibb.co/cv0HXB9/We-Chat-Screenshot-20230817134700.png"
    },
    {
        ID: 'AD',
        name: '宣传部门(Advertising)',
        description: ['AD_D'],
        img:"https://i.ibb.co/fXgdVzt/We-Chat-Screenshot-20230817134408.png"}
]